module.exports = __webpack_public_path__ + "static/media/app-icon-ny.5ed5d049.svg";